import { Injectable } from '@angular/core';
import { createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as LandingPageActions from '../actions/landing-page.actions';
import { LandingPageExtendedEffects } from './landing-page-extended.effects';

@Injectable()
export class LandingPageEffects extends LandingPageExtendedEffects {
  loadAEMMedallionBannerContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadAEMMedallionBanner),
      switchMap(() =>
        this.data.getMedallionBannerContent().pipe(
          map((content) =>
            LandingPageActions.loadAEMMedallionBannerSuccess({
              aemMedallionBannerContent: {
                id: 'aem-medallion-banner',
                aemMedallionBanner: content
              }
            })
          ),
          catchError(() =>
            of(
              LandingPageActions.loadAEMMedallionBannerFailure({
                aemErrorContent: {
                  id: 'aem-medallion-banner-error',
                  aemMedallionBannerError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  loadAEMMenuContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadAEMMenu),
      switchMap(() =>
        this.data.getMenuContent().pipe(
          map((content) =>
            LandingPageActions.loadAEMMenuSuccess({
              aemMenuContent: {
                id: 'aem-menu',
                aemMenu: content
              }
            })
          ),
          catchError(() =>
            of(
              LandingPageActions.loadAEMMenuFailure({
                aemMenuErrorContent: {
                  id: 'aem-menu-error',
                  aemMenuError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  loadFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadAEMFeatureFlags),
      switchMap(() =>
        this.data.getFeatureFlags().pipe(
          map((content) =>
            LandingPageActions.loadAEMFeatureFlagsSuccess({
              aemFeatureFlags: {
                id: 'aem-feature-flags',
                aemFeatureFlags: content
              }
            })
          ),
          catchError(() =>
            of(
              LandingPageActions.loadAEMFeatureFlagsFailure({
                aemFeatureFlagsError: {
                  id: 'aem-feature-flags-error',
                  aemFeatureFlagsError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  loadErrorMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadAEMErrorMessages),
      switchMap(() =>
        this.data.getErrorMessages().pipe(
          map((content) =>
            LandingPageActions.loadAEMErrorMessagesSuccess({
              aemErrorMessages: {
                id: 'aem-error-messages',
                aemErrorMessages: content.errorMessagesSection.errormessages
              }
            })
          ),
          catchError(() =>
            of(
              LandingPageActions.loadAEMErrorMessagesFailure({
                aemErrorMessagesError: {
                  id: 'aem-error-messages-error',
                  aemErrorMessagesError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );
}
